<template>
  <div :class="['sj-card', type]">
    <slot></slot>
  </div>
</template>

<script>
/**
 * card组件，为一个可自定义内容的显示区域，无额外功能。
 */
export default {
  name: "SjCard",
  props: {
    type: {
      type: String,
      default: "normal",
      validator: val =>
        ["normal", "index", "content", "dark", "transparent"].includes(val)
    }
  }
};
</script>

<style lang="less" scoped>
.sj-card {
  border-radius: @base-border-radius;
  box-sizing: border-box;
  &.normal {
    background-color: @color-antibg;
    box-shadow: 0px 4px 6px 0px rgba(144, 164, 183, 0.22);
  }
  &.index {
    background-color: @color-antibg;
    box-shadow: 0px 0px 3px 2px rgba(0, 0, 0, 0.03);
  }
  &.content {
    background-color: @color-antibg;
    box-shadow: 0px 4px 6px 0px rgba(144, 164, 183, 0.22),
      0px 5px 10px 3px rgba(216, 216, 216, 0.4);
  }
  &.dark {
    background-color: @color-available;
  }
  &.transparent {
    background-color: transparent;
  }
}
</style>
